<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="card-title">
                <h5 class="float-left">Products</h5>
                <b-button
                  variant="primary"
                  class="btn btn-label btn-primary float-right"
                  v-b-modal.modal_addProduct
                  ><i class="bx bx-plus label-icon"></i>Add Product</b-button
                >
                <!-- Add User Modal -->
                <b-modal
                  id="modal_addProduct"
                  title="Add Product"
                  title-class="font-18"
                  ok-title="Add Product"
                  @ok="addProduct"
                  @close="clearModal"
                  @cancel="clearModal"
                >
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Product</label>
                      <b-form-input
                        placeholder="Product..."
                        v-model="productName"
                        :state="
                          submitErrorName === null
                            ? validateEntry('name')
                            : submitErrorName
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productNameErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Purchase Price</label>
                      <b-form-input
                        placeholder="Purchase Price..."
                        v-model="productPrice"
                        :state="
                          submitErrorPrice === null
                            ? validateEntry('price')
                            : submitErrorPrice
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productPriceErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Default Billable Rate</label>
                      <b-form-input
                        placeholder="Default Billable Rate..."
                        v-model="productRate"
                        :state="
                          submitErrorRate === null
                            ? validateEntry('rate')
                            : submitErrorRate
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productRateErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-modal>
                <!-- /Add User Modal -->
                <!--  -->
                <!--  -->
                <!-- Edit User Modal -->

                <b-modal
                  id="modal_editProduct"
                  title="Edit Product"
                  title-class="font-18"
                  ok-title="Edit Product"
                  @ok="editProduct"
                  @close="clearModal"
                  @cancel="clearModal"
                >
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Product</label>
                      <b-form-input
                        placeholder="Product..."
                        v-model="productName"
                        :state="
                          submitErrorName === null
                            ? validateEntry('name')
                            : submitErrorName
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productNameErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Purchase Price</label>
                      <b-form-input
                        placeholder="Purchase Price..."
                        v-model="productPrice"
                        :state="
                          submitErrorPrice === null
                            ? validateEntry('price')
                            : submitErrorPrice
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productPriceErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="form-group">
                      <label>Default Billable Rate</label>
                      <b-form-input
                        placeholder="Default Billable Rate..."
                        v-model="productRate"
                        :state="
                          submitErrorRate === null
                            ? validateEntry('rate')
                            : submitErrorRate
                        "
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback">
                        {{ productRateErrorMessage }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-modal>
                <!-- /Edit User Modal -->
                <!--  -->
                <!--  -->
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-12 col-md-12">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        v-model="productsPerPage"
                        size="sm"
                        :options="productsPageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="products-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="productsFilter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->

              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="productsPerPage"
                  :current-page="productsCurrentPage"
                  :sort-by.sync="productsSortBy"
                  :sort-desc.sync="productsSortDesc"
                  :filter="productsFilter"
                  :filter-included-fields="productsFilterOn"
                >
                  <template v-slot:cell(edit)="data">
                    <b-dropdown variant="primary" size="sm">
                      <template v-slot:button-content>
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-b-modal.modal_editProduct
                        @click="populateEditProduct(data.item)"
                        ><i class="bx bx-pencil mr-2 tableIcons"></i
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item @click="deleteProduct(data.item.edit)"
                        ><i class="bx bx-trash mr-2 tableIcons"></i
                        >Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </template>
                </b-table>
              </div>
              <!-- /Table -->
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="productsCurrentPage"
                        :total-rows="productsTotalRows"
                        :per-page="productsPerPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!--/Row-->
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
  </div>
</template>
<script>
import { firestore } from 'firebase';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      productName: null,
      productRate: null,
      productPrice: null,
      productNameValid: false,
      productRateValid: false,
      productPriceValid: false,
      editID: null,
      submitErrorName: null,
      submitErrorRate: null,
      submitErrorPrice: null,

      productNameErrorMessage: null,
      productRateErrorMessage: null,
      productPriceErrorMessage: null,

      tableData: [],
      fields: [
        { key: 'edit' },
        { key: 'displayName', label: 'Name', sortable: true },
        { key: 'price', sortable: true },
        { key: 'defaultRate', label: 'Default Billable Rate', sortable: true },
      ],
      productsSortBy: 'name',
      productsSortDesc: false,
      productsPerPage: 10,
      productsTotalRows: 1,
      productsCurrentPage: 1,
      productsPageOptions: [10, 25, 50, 100],
      productsFilter: null,
      productsFilterOn: [],
      currentUser: [],
    };
  },
  methods: {
    addProduct(bvModalEvt) {
      if (
        this.productNameValid &&
        this.productRateValid &&
        this.productPriceValid
      ) {
        try {
          let product = {
            defaultRate: this.productRate.trim(),
            price: this.productPrice.trim(),
            displayName: this.productName.trim(),
            name: this.productName.trim().toLowerCase(),
            org: sessionStorage.org,
          };
          firestore()
            .collection('products')
            .add(product)
            .then((doc) => {
              product['edit'] = doc.id;
              this.tableData.push(product);
              this.clearModal();
              Swal.fire('Success!', 'Product added successfully.', 'success');
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when adding the product.',
            'error'
          );
        }
      } else {
        this.submitErrorName = this.validateEntry('name', true);
        this.submitErrorRate = this.validateEntry('rate', true);
        this.submitErrorPrice = this.validateEntry('price', true);
        bvModalEvt.preventDefault();
      }
    },
    editProduct(bvModalEvt) {
      if (
        this.productNameValid &&
        this.productRateValid &&
        this.productPriceValid
      ) {
        try {
          let product = {
            defaultRate: this.productRate.trim(),
            price: this.productPrice.trim(),
            displayName: this.productName.trim(),
            name: this.productName.trim().toLowerCase(),
            org: sessionStorage.org,
          };
          firestore()
            .collection('products')
            .doc(this.editID)
            .update(product)
            .then(() => {
              product['edit'] = this.editID;
              let index = this.tableData.findIndex(
                (data) => data.edit === this.editID
              );
              this.tableData.splice(index, 1, product);

              this.clearModal();
              Swal.fire('Success!', 'Product edited successfully.', 'success');
            });
        } catch (error) {
          console.log(error);
          Swal.fire(
            'Error!',
            'An error was encountered when editing the product.',
            'error'
          );
        }
      } else {
        this.submitErrorName = this.validateEntry('name', true);
        this.submitErrorRate = this.validateEntry('rate', true);
        this.submitErrorPrice = this.validateEntry('price', true);

        bvModalEvt.preventDefault();
      }
    },
    deleteProduct(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          try {
            firestore()
              .collection('products')
              .doc(id)
              .delete()
              .then(() => {
                this.tableData = this.tableData.filter(function (obj) {
                  return obj.edit !== id;
                });
                Swal.fire(
                  'Success!',
                  'Product deleted successfully.',
                  'success'
                );
              });
          } catch (error) {
            console.log('Error deleting product', error);
            Swal.fire(
              'Error!',
              'An error was encountered when deleting the product.',
              'error'
            );
          }
        }
      });
    },
    populateEditProduct(data) {
      this.productName = data.displayName;
      this.productRate = data.defaultRate;
      this.productPrice = data.price ? data.price : '';
      this.editID = data.edit;
    },
    clearModal() {
      this.productName = null;
      this.productRate = null;
      this.productPrice = null;

      this.productNameValid = false;
      this.productRateValid = false;
      this.productPriceValid = false;

      this.editID = null;
      this.submitErrorName = null;
      this.submitErrorRate = null;
      this.submitErrorPrice = null;

      this.productNameErrorMessage = null;
      this.productRateErrorMessage = null;
      this.productPriceErrorMessage = null;
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_products) {
          this.productsPerPage =
            this.currentUser.tablePageLengths.perPage_products;
        }
      }
    },
    getProducts: async function () {
      let index;
      try {
        firestore()
          .collection('products')
          .where('org', '==', sessionStorage.org)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              index = this.tableData.push(doc.data());
              this.tableData[index - 1]['edit'] = doc.id;
            });
          });
      } catch (error) {
        console.log('Error getting product data', error);
      }
    },

    validateEntry(entry, submitted) {
      if (entry === 'name') {
        if (this.productName === null || this.productName.trim() === '') {
          if (submitted) {
            this.productNameValid = false;
            this.productNameErrorMessage = 'Please enter a product';
            return false;
          } else {
            this.productNameValid = false;
            this.productNameErrorMessage = 'Please enter a product';
            return null;
          }
        } else {
          this.productNameValid = true;
          return true;
        }
      }
      if (entry === 'rate') {
        if (
          this.productRate === null ||
          this.productRate.toString().trim() === ''
        ) {
          if (submitted) {
            this.productRateValid = false;
            this.productRateErrorMessage = 'Please enter a rate';
            return false;
          } else {
            this.productRateValid = false;
            this.productRateErrorMessage = 'Please enter a rate';
            return null;
          }
        } else if (!isNaN(Number(this.productRate))) {
          this.productRateValid = true;
          return true;
        } else {
          this.productRateValid = false;
          this.productRateErrorMessage = 'Rate must be a number';
          return false;
        }
      }
      if (entry === 'price') {
        if (
          this.productPrice === null ||
          this.productPrice.toString().trim() === ''
        ) {
          this.productPriceValid = true;
          return null;
        } else if (!isNaN(Number(this.productPrice))) {
          this.productPriceValid = true;
          return true;
        } else {
          this.productPriceValid = false;
          this.productPriceErrorMessage = 'Purchase Price must be a number';
          return false;
        }
      }
    },
  },
  mounted() {
    this.getProducts();
    this.setTableSettings();
  },
  watch: {
    productName() {
      if (this.submitErrorName !== null) {
        this.submitErrorName = null;
      }
    },
    productRate() {
      if (this.submitErrorRate !== null) {
        this.submitErrorRate = null;
      }
    },
    productPrice() {
      if (this.submitErrorPrice !== null) {
        this.submitErrorPrice = null;
      }
    },
    productsPerPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_products){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_products;
          }
          currentUserDataCopy.tablePageLengths['perPage_products'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_products: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
};
</script>
